<template>
  <div v-if="metadata && metadata.form">
    <base-v-component
      :heading="metadata.form.title"
    />
    <base-material-card
      color="primary"
      icon="mdi-cart"
      inline
    >
      <template v-slot:after-heading>
        <div class="text-h3 font-weight-light">
          {{ metadata.form.title }}
        </div>
      </template>
      <div>
        <v-row justify="center">
          <v-col
            v-if="metadata.form"
            cols="12"
          >
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-tabs
                      v-if="metadata.form.tabs"
                      show-arrows
                    >
                      <v-tab
                        v-for="(tab, tab_index) in metadata.form.tabs"
                        :key="'tab_h_'+ tab_index"
                      >
                        <v-icon left>
                          {{ tab.icon || 'mdi-cog' }}
                        </v-icon>{{ tab.title }}
                      </v-tab>
                      <v-tab-item
                        v-for="(tab, tab_index) in metadata.form.tabs"
                        :key="'tab_b_'+ tab_index"
                        class="mt-4"
                      >
                        <row
                          v-for="(row, row_index) in tab.rows"
                          :key="'row_'+ row_index"
                          dense
                          :row="row"
                          :form="form"
                        />
                        <v-row
                          dense
                          class="justify-center"
                        >
                          <slot
                            :name="'tab' + tab_index"
                            :form="form"
                          /> <!--динамическое имя слота tab0, tab1, tab2 и биндим туда form -->
                        </v-row>
                      </v-tab-item>
                    </v-tabs>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row class="justify-center">
                  <v-col
                    cols="6"
                    md="3"
                  >
                    <v-btn
                      color="primary"
                      outlined
                      @click="$router.go(-1)"
                    >
                      <span class="mx-3">Отмена</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="6"
                    md="3"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      @click="save"
                    >
                      <span class="mx-3">Сохранить</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </base-material-card>
  </div>
</template>
<style lang="scss">
  .v-window.v-tabs-items {
    overflow: visible;
  }
</style>
<script>
export default {
  props: {
    entity: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null
    },
  },
  data: () => ({
    file: null,
    form: {},
    metadata: {},
    metadataAll: {},
  }),
  computed: {
  },
  watch: {
    metadata: {
      handler (newValue, oldValue) {
        // console.log('this.metadata watch', this.metadata)
        if (this.metadata && this.metadata !== {}) {
          this.init()
        }
      },
      deep: true
    },
    form: {
      handler () {
        if (this.entity === 'sbpprofile') {
          // console.log('form is changed', newValue)
          // console.log('this.metadataAll', this.metadataAll)
          this.metadata.form.tabs[1].rows = this.metadataAll.form.tabs[1].rows.filter(row => {
            return row.fields.every(field => field.if_value == this.form.type)
          })
        }
      },
      deep: true,
    }
  },
  mounted: function () {
    if (!this.entity) return
    this.load_metadata()
  },
  methods: {
     load_metadata () {
      this.axios.post('/api/' + this.entity + '/metadata', {})
        .then(result => {
          this.form.id = null
          if (!result.data.error) {
            this.metadata = result.data.data
            // console.log('metadata  is mounted', this.metadata)
            // change type 7 (autocomplete) to 3 (select)
            if (this.entity === 'nomenclature' || this.entity === 'sbpprofile' || this.entity === 'sbp') {
              this.metadata.form.tabs = this.metadata.form.tabs.map(tab => {
                tab.rows.map(row => {
                  row.fields.map(field => {
                    if (field.type === 7) {
                      field.type = 3
                    }
                    return field
                  })
                  return row
                })
                return tab
              })
            }
            if (!this.id) {
              this.init()
            } else {
              this.load_form(this.id)
            }
            this.metadataAll = JSON.parse(JSON.stringify(this.metadata))
            // console.log('metadataAll is mounted', this.metadataAll)
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
    },
    load_form (id) {
      this.axios
        .post('/api/' + this.entity + '/list', { id: id })
        .then(response => {
          if (!response.data.error) {
            this.form = response.data.data[0]
            // console.log('load_form this.form', this.form)
            if (this.entity === 'task') {
              if (Object.hasOwn(this.form, 'created')) {
                this.form.created = this.form.created.split('T')[0]
              }
            }
            if (this.entity === 'sbpprofile') {
              this.metadata.form.tabs[1].rows = this.metadata.form.tabs[1].rows.filter(row => {
                return row.fields.every(field => field.if_value == this.form.type)
                })
            }
          } else {
            this.$store.commit("snackbar", response.data.data)
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit("snackbar", e)
        })
    },
    save () {
      let path = '/api/' + this.entity + '/save'
      if (!this.form.id) path = '/api/' + this.entity + '/create'
      this.axios
        .post(path, this.form)
        .then(response => {
          if (!response.data.error) {
            this.$router.push(this.path + '/list')
          } else {
            this.$store.commit("snackbar", response.data.data)
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit("snackbar", e)
        })
    },
    init: function () {
      if (this.metadata && this.metadata.form && this.metadata.form.tabs) {
        for (const tab_pos in this.metadata.form.tabs) {
          for (const row_pos in this.metadata.form.tabs[tab_pos].rows) {
            for (const field_pos in this.metadata.form.tabs[tab_pos].rows[row_pos].fields) {
              const field = this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos]
              if (field.level == 1) {
                if (!this.form[field.key]) {
                  this.set_default_value(this.form, field.key, field)
                }
              }
              if (field.level == 2) {
                if (!this.form[field.key1]) {
                  this.form[field.key1] = {}
                }
                if (!this.form[field.key1][field.key2]) {
                  this.set_default_value(this.form[field.key1], field.key2, field)
                }
              }
              if (field.level == 3) {
                if (!this.form[field.key1]) {
                  this.form[field.key1] = {}
                }
                if (!this.form[field.key1][field.key2]) {
                  this.form[field.key1][field.key2] = {}
                }
                if (!this.form[field.key1][field.key2][field.key3]) {
                  this.set_default_value(this.form[field.key1][field.key2], field.key3, field)
                }
              }
            }
          }
        }
      }
    },
    set_default_value (form, key, field) {
      this.$set(
        form,
        key,
        (
          (field.type === 1 ? 0
            : (
              field.type === 5 ? []
              : (
                field.type === 6 ? {} : field.default_value
              )
            )
          )
        )
      )
    }
  }
}
</script>
